<script setup>

import SummaryAmountsList from '@/components/list/SummaryAmountsList.vue'

</script>

<template>

<SummaryAmountsList />

</template>
